import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Minus, MessageCircleQuestion } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";
import SectionHeading from "../SectionHeading";
import Reveal from "../Reveal";

const FAQItem = ({ q, a, open, onToggle, idx }) => (
  <div
    className={`rounded-2xl border transition-colors ${open ? "border-amber-500/50 bg-white shadow-lg shadow-amber-500/5" : "border-slate-200 bg-white hover:border-slate-300"}`}
    data-testid={`faq-item-${idx}`}
  >
    <button
      onClick={onToggle}
      aria-expanded={open}
      className="w-full flex items-center justify-between gap-6 text-left px-6 py-5"
      data-testid={`faq-toggle-${idx}`}
    >
      <span className="font-display font-semibold text-navy-900 text-base md:text-lg">{q}</span>
      <span className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${open ? "bg-amber-500 text-navy-950" : "bg-slate-100 text-slate-500"}`}>
        {open ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
      </span>
    </button>
    <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
      <div className="overflow-hidden">
        <p className="px-6 pb-6 text-slate-600 leading-relaxed">{a}</p>
      </div>
    </div>
  </div>
);

const FAQ = () => {
  const { lang } = useLanguage();
  const t = translations[lang].faq;
  const [open, setOpen] = useState(0);

  return (
    <section className="bg-slate-50 py-20 lg:py-28" data-testid="home-faq">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2">
          <SectionHeading tag={t.tag} title={t.title} desc={t.desc} />
          <div className="mt-8 rounded-2xl bg-navy-900 p-6 flex items-start gap-4">
            <div className="w-11 h-11 rounded-xl bg-amber-500/15 flex items-center justify-center shrink-0">
              <MessageCircleQuestion className="w-5 h-5 text-amber-400" />
            </div>
            <div>
              <p className="text-white font-semibold">{t.moreTitle}</p>
              <p className="text-slate-300 text-sm mt-1">{t.moreDesc}</p>
              <Link to="/iletisim" className="mt-3 inline-block text-amber-400 font-semibold text-sm hover:text-amber-300" data-testid="faq-contact-link">
                {t.moreCta} →
              </Link>
            </div>
          </div>
        </div>
        <div className="lg:col-span-3 space-y-3">
          {t.items.map((it, i) => (
            <Reveal key={i} delay={i * 60}>
              <FAQItem q={it.q} a={it.a} idx={i} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
